module.exports = __webpack_public_path__ + "img/logo_2.f49af88a.png";